import { createAction } from '@reduxjs/toolkit';

import type {
  CreateLanguageTranslationPayload,
  DeleteTranslationPayload,
  UpdateLanguageTranslationPayload,
} from '@polyai/schemas';

export const PREFIX = 'translations';

export const updateTranslation = createAction<UpdateLanguageTranslationPayload>(
  `${PREFIX}/updateTranslation`,
);

export const createTranslation = createAction<CreateLanguageTranslationPayload>(
  `${PREFIX}/createTranslation`,
);

export const deleteTranslation = createAction<DeleteTranslationPayload>(
  `${PREFIX}/deleteTranslation`,
);
